import { expiredSession } from "./expired-session";

export const noAuthPT = {
	expiredSession,
	login: {
		dashboard: "Dashboard",
	},
};
